import {postData, WP_Localized_Data} from "../Utils/Utils.js";
import WPBlockVimeoEmbed from "./WPBlockVimeoEmbed.js";
import WPBlockYouTubeEmbed from "./WPBlockYouTubeEmbed.js";

const ACFBlockProductOptions = (domEl) => {

	let isLocked = false;
	let lightboxContent = null;

	const loadDetailsIntoLightbox = (e) => {
		if(e) {
			e.preventDefault();
		}

		if(isLocked) {
			return;
		}
		isLocked = true;

		// Append nonce and the action so the ajax callback
		const task = WP_Localized_Data.tasks.loadProductOption; // From theme-setup.php
		const formData = new FormData();
		formData.append('action', task.action);
		formData.append('nonce', task.nonce);
		formData.append('id', e.currentTarget.dataset.id);

		postData(task.url, formData)
			.then(response => {

				if(!response.success) {
					isLocked = false;
				}
				else {

					lightboxContent = document.createElement('div');
					lightboxContent.innerHTML = response.data.data;

					const lightbox = document.querySelector('#lightbox');
					lightbox.querySelector('.lightbox-placeholder').innerHTML = '';
					lightbox.querySelector('.lightbox-placeholder').appendChild(lightboxContent);

					lightboxContent.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new WPBlockVimeoEmbed(block));
					lightboxContent.querySelectorAll('.wp-block-embed-youtube').forEach(block => new WPBlockYouTubeEmbed(block));

					document.addEventListener('LIGHTBOX_CLOSED', handleLightboxClosed);
					document.body.classList.add('js-lightbox-revealed');
				}
			})
			.catch(function(err) {
				isLocked = false;
			});
	}

	const handleLightboxClosed = () => {
		if(lightboxContent) {
			lightboxContent.parentNode.removeChild(lightboxContent);
			lightboxContent = null;
		}
		isLocked = false;
	}


	domEl.querySelectorAll('.product-teaser button.read-more').forEach(btn => btn.addEventListener('click', loadDetailsIntoLightbox));
};

export default ACFBlockProductOptions;